module.exports = __webpack_public_path__ + "static/media/juice_machine.8d78e43b.png";